// @flow

import {
  createEditorUrl,
  isFlowTemplate,
} from 'app/beta-editor/utils/FlowUtils';

import type { RequiredBehaviors } from 'app/beta-editor/pages/types';

const overviewBehavior: RequiredBehaviors = {
  label() {
    return 'Zap Overview';
  },

  menuLabel() {
    return 'Zap Overview';
  },

  crumbLabel() {
    return 'Overview';
  },

  data() {
    return;
  },

  status() {
    return 'success';
  },

  visible() {
    return true;
  },

  isClickable() {
    return true;
  },

  isLocked() {
    return false;
  },

  href({ flow }) {
    const isTemplate = isFlowTemplate(flow.nodes);
    return createEditorUrl({
      flowId: flow.id,
      pageKey: 'overview',
      isTemplate,
    });
  },
};

export default overviewBehavior;
